import axios from "axios";
import { ONBOARDING_API_ENDPOINT } from "../../../config/url.config";
import { navigateToSessionExpired } from "../../../utils/sessionExpired";
import { documentsWasUpdatedByUser } from "../../../utils/updatedByUser";
import { getAuthHeader } from "../../../utils/superFetch";

export const handleLoadVocationalLicense = (itemIndex, requirementDocuments, setVocationalLicense, setUserUploadedLicense, vocationalLicenseImg, setVlExpiry, setVlIssueDate) => {
    setVocationalLicense(vocationalLicenseImg)
    for (let requiredItems of requirementDocuments[itemIndex].requiredItems) {
        if ( requiredItems.value !== "" && requiredItems.itemName === "vocationalLicense") {
            setUserUploadedLicense(true)
            setVocationalLicense(requiredItems.url);
        } 

        if ( requiredItems.value !== "" && requiredItems.itemName === "expiryDate") {
          setVlExpiry(requiredItems.value);
        }
        
        if ( requiredItems.value !== "" && requiredItems.itemName === "issueDate") {
          setVlIssueDate(requiredItems.value);
        }
    }
}

export const handleSaveVlExpiryInformation = async (vlExpiryDate, vlIssueDate, profileId, memberRequirement,setMemberRequirement, itemIndex) => {
  let body = {
    item: "vocationalLicense",
    requiredItems: [

    ],
  };

  if (vlExpiryDate !== "") {
    body.requiredItems.push({
      itemName: "expiryDate",
      value: vlExpiryDate,
    });
  }

  if (vlIssueDate !== "") {
    body.requiredItems.push({
      itemName: "issueDate",
      value: vlIssueDate,
    });
  }

  if (body.requiredItems.length === 0) {
    return
  }
  
  const config = {
    headers: {
      "content-type": "application/json",
      "upload-document": false,
      ...getAuthHeader(),
    },
  };

  try {
    const res = await axios.post(
      `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${profileId}`,
      body,
      config
    );

    if (res.status) {
      let tmpMemberData = { ...memberRequirement };

      for ( let i = 0; i < tmpMemberData.requiredDocuments[itemIndex].requiredItems.length; i++ ) {
        if ( tmpMemberData.requiredDocuments[itemIndex].requiredItems[i].itemName === "expiryDate") {
          updateMemberRequirement(
            memberRequirement,
            setMemberRequirement,
            itemIndex,
            tmpMemberData.requiredDocuments[itemIndex].requiredItems[i]
              .itemName,
              vlExpiryDate
          );
        }
      }
    }
    return
  } catch (err) {
    
    return
  }
};

export const updateMemberRequirement = (memberRequirement,setMemberRequirement, itemIndex, itemName, updatedValue, updatedUrl) => {
    let tmpData = {...memberRequirement}
    for (let i = 0 ; i< tmpData.requiredDocuments[itemIndex].requiredItems.length ;i++) {
      if (
        itemName === tmpData.requiredDocuments[itemIndex].requiredItems[i].itemName
      ) {
        if(tmpData.requiredDocuments[itemIndex].requiredItems[i].status === 2 || 
          tmpData.requiredDocuments[itemIndex].requiredItems[i].value !== '') {
          documentsWasUpdatedByUser(`${tmpData.requiredDocuments[itemIndex].item}`)
        }
        tmpData.requiredDocuments[itemIndex].requiredItems[i].value = updatedValue
        tmpData.requiredDocuments[itemIndex].requiredItems[i].url = updatedUrl
        break
      }
    }
    setMemberRequirement(tmpData)
    return
}

export const handelImageUpload = async (file, itemName, item, setLoePicture, setValidation,
     profileid, setUserUploadedLoe, navigate, memberRequirement,setMemberRequirement, itemIndex) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("inputType", "image");
    formData.append("itemName", itemName);
    formData.append("item", item);

    const config = {
        headers: {
          "content-type": "multipart/form-data",
          "upload-document": true,
          ...getAuthHeader(),
        },
    };

    try {
        const endpoint = `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${profileid}`;
        const res = await axios.post(endpoint, formData, config);
  
        setLoePicture(URL.createObjectURL(file))
        setValidation({ show: false, message: "", class: "" })
        setUserUploadedLoe(true)
        updateMemberRequirement(memberRequirement,setMemberRequirement, itemIndex, itemName, res.data.result.itemValue, res.data.result.url)
        
        
      } catch (err) {
        navigateToSessionExpired(navigate, {
          reason: "vocational_license_upload_failed",
          source: "handelImageUpload",
          component: "VocationalLicense",
          status: err?.response?.status,
          message: err?.message,
          item,
          itemName,
        });
      }
}

export const handleVocationalUpload = async (e, setValidation, setLicenseLoading, setUserUploadedLicense,
     itemName, item, profileid, setVocationalLicense, navigate, memberRequirement,setMemberRequirement, itemIndex) => {
    let file = e.target.files[0];
    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type) || file.size/1000000 > 7) {
        setValidation({
            show: true,
            message:
              "Invalid image. Only images of type png, jpg, jpeg with size below 7mb can be uploaded",
            class: "error-msg",
          });
        return;
    }
    setLicenseLoading(() => true)
    await handelImageUpload(file, itemName, item, setVocationalLicense, setValidation,
        profileid, setUserUploadedLicense, navigate, memberRequirement,setMemberRequirement, itemIndex)
    setLicenseLoading(() => false)
}